// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3359":"293d5bc5","3903":"40f59ef4","5454":"40f59ef4","9042":"40f59ef4"}[chunkId] + ".chunk.css";
};